<div class="slide slide--executive" [style.--slide-accent-color]="titleColor">
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>

			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>

			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>
	</div>

	<div class="slide__kpi-grid" *ngIf="!isEmpty">
		<div
			class="slide__kpi-card"
			*ngFor="let card of kpiCards; trackBy: trackByKpiId"
			[matTooltip]="card.source"
			matTooltipPosition="above"
			matTooltipClass="report-source-tooltip"
		>
			<div class="slide__kpi-top">
				<span class="slide__kpi-dot" [ngClass]="card.dotClass"></span>
				<typography variant="p/xs_regular" class="slide__kpi-label">
					{{ card.label }}
				</typography>
			</div>

			<typography variant="h/2" class="slide__kpi-value">
				{{ card.value }}
			</typography>

			<div class="slide__kpi-meta" *ngIf="card.delta">
				<span
					class="slide__kpi-delta"
					[ngClass]="card.delta.directionClass"
				>
					{{ card.delta.arrow }} {{ card.delta.text }}
				</span>
				<span class="slide__kpi-suffix" *ngIf="card.suffix">
					{{ card.suffix }}
				</span>
			</div>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>

	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">summary</div>
	</div>
</div>
